export const REQUEST_HISTORY_GRID_COLUMN = {
  EVENT_NAME: "EventName",
  VENUE_NAME: "VenueName",
  EVENT_DATE: "EventDate",
  PURCHASE_DATE: "PurchaseDate",
  STATUS: "Status",
  BUYER_NAME: "BuyerName",
  QUANTITY: "Quantity",
  SECTION: "Section",
  ROW: "Row",
  SEATS: "Seats",
  TOTAL_COST: "TotalCost",
  COST_PER_TICKETS: "CostPreTicket",
  REASON: "Reason",
  REWARD: "Reward",
  APPROVED: "Approved",
  MANAGE: "Manage",
  ADDITIONAL_INFO_MANAGE: "AdditionalInfoManage",
}

export const DEFAULT_REQUEST_HISTORY_GRID_STYLE = () => {
  let index = 1;

  const array = Object.keys(REQUEST_HISTORY_GRID_COLUMN).map(key => ({
    name: REQUEST_HISTORY_GRID_COLUMN[key],
    index: index++
  }));

  return array;
}